module.exports = __webpack_public_path__ + "static/S-Factor_OfficeManagerOperationsManager_PD-44d91b6726ded08947214c082662de4e.pdf";